module.exports = __webpack_public_path__ + "static/media/Robb Stark 2.03dfe931.jpg";